import { render, staticRenderFns } from "./ConteudoModal.vue?vue&type=template&id=7dd6c1f1&scoped=true"
import script from "./ConteudoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConteudoModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ConteudoModal.vue?vue&type=style&index=0&id=7dd6c1f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd6c1f1",
  null
  
)

export default component.exports